
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-safe/recreate",
      function () {
        return require("private-next-pages/new-safe/recreate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-safe/recreate"])
      });
    }
  